import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=a622b0b6&scoped=true&"
import script from "./integralDetails.vue?vue&type=script&lang=js&"
export * from "./integralDetails.vue?vue&type=script&lang=js&"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=a622b0b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a622b0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a622b0b6')) {
      api.createRecord('a622b0b6', component.options)
    } else {
      api.reload('a622b0b6', component.options)
    }
    module.hot.accept("./integralDetails.vue?vue&type=template&id=a622b0b6&scoped=true&", function () {
      api.rerender('a622b0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myIntegral/integralDetails.vue"
export default component.exports